// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import routing from './routing'
import alert from './alert'

const rootReducer = {
  alert,
  auth,
  navbar,
  layout,
  routing
}

export default rootReducer
